import { useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { ShieldAlert, Loader2, ScanLine } from 'lucide-react'
import SecurityFindingsList from '../../../../components/Security/SecurityFindingsList'
import { securityApi } from '../../../../services/securityApi'

export default function SecuritySection({ device }) {
  const queryClient = useQueryClient()
  const [scanning, setScanning] = useState(false)
  const [message, setMessage] = useState(null)

  const scanNow = async () => {
    setScanning(true)
    setMessage(null)
    try {
      const r = await securityApi.scanNow(device.id)
      setMessage(r?.reachable === false
        ? `Sem acesso de gestão ao device: ${r.error || 'motivo não informado'}`
        : `Varredura concluída: ${(r.findings || []).length} achado(s).`)
      await queryClient.invalidateQueries({ queryKey: ['securityFindings'] })
      await queryClient.invalidateQueries({ queryKey: ['securityOverview'] })
    } catch (e) {
      setMessage(e.response?.data?.message || e.message)
    } finally {
      setScanning(false)
    }
  }

  return (
    <section className="bg-white border border-gray-200 rounded-lg p-4">
      <div className="flex items-center gap-2 mb-1">
        <ShieldAlert className="w-4 h-4 text-theme-primary" />
        <h3 className="text-sm font-semibold text-gray-900">Segurança</h3>
        <button
          onClick={scanNow}
          disabled={scanning}
          className="ml-auto inline-flex items-center gap-1 text-xs px-2 py-1 bg-theme-primary text-white rounded hover:opacity-90 disabled:opacity-50"
        >
          {scanning ? <Loader2 className="w-3 h-3 animate-spin" /> : <ScanLine className="w-3 h-3" />}
          Varrer agora
        </button>
      </div>
      <p className="text-xs text-gray-500 mb-3">
        Varredura somente leitura: usuários e chaves, scheduler/scripts de persistência, portas de gestão
        expostas na internet, firewall de input, logging e serviços de risco. Nada é alterado no equipamento.
      </p>
      {message && (
        <div className="mb-3 p-2 bg-gray-50 border border-gray-200 rounded text-xs text-gray-700">{message}</div>
      )}
      <SecurityFindingsList deviceId={device.id} />
    </section>
  )
}
